import { render } from "./ChatBotLinks.vue?vue&type=template&id=3196d83d"
import script from "./ChatBotLinks.vue?vue&type=script&lang=js"
export * from "./ChatBotLinks.vue?vue&type=script&lang=js"

import "./ChatBotLinks.vue?vue&type=style&index=0&id=3196d83d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__